// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import headshot from 'images/headshot-retouched-min.png';
import Icon from 'components/Icon';
import Link from 'components/Link';
import { sendEvent } from 'lib/analytics';

// local
import styles from './AboutSection.pcss';

const PHONE_NUMBER = '503-346-0640';


export default class AboutSection extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}
  
  state = { expand: false }
  
  handleToggleExpand = () => {
    sendEvent('show-more', 'about');
    this.setState({
      expand: !this.state.expand,
    });
  }
  
  render() {
    const { className } = this.props;
    const { expand } = this.state;
    
    const classNames = classnames(className, styles.aboutSection);
    const moreClassNames = classnames(styles.more, {
      [styles.active]: expand,
    });
    
    return (
      <div
        id={ 'about' }
        className={ classNames }
      >
        <div className={ styles.headshot } >
          <img alt={ 'headshot' } src={ headshot } />
        </div>
        
        <div className={ styles.intro }>
          <div className={ styles.box }>
            <h1 className={ styles.title }>{ 'About' }</h1>
            
            <p>
              { `
                Dr. Seideman is a pediatric urologist at Doernbecher Children’s Hospital at OHSU in `
                
              }
              <Link to={ '/map' }>{ 'Portland, OR' }</Link>
              {
                `.
                She takes care of kids and young adults with diseases and disorders of urination, 
                reproductive organs and/or testes.
              `
              }
              
              <Icon
                className={ styles.toggleMore }
                hidden={ expand }
                type={ 'expand_more' }
                onClick={ this.handleToggleExpand } />
            </p>
          </div>
        </div>
        
        <div className={ moreClassNames }>
          
          <p>
            { `
              Dr. Seideman has extensive training in minimally invasive surgery and reconstruction, and 
              is interested in improving patients’ and parents’ quality of life.
              She is co-director of the Doernbecher Sex Development program; a specialized team that works with 
              families to develop a treatment plan to address the unique needs of each child.
            ` }
          </p>
          <p>
            { `
              She is also co-director of the Pediatric Kidney Stone clinic - which combines urology, 
              nephrology and diet - for a multidisciplinary approach to this growing issue. 
            ` }
          </p>
          <p>
            { `
              For more information, or to schedule an appointment please contact the Pediatric Urology 
              office at Doernbecher Children’s Hospital at 
            ` }
            <Link to={ `tel:${ PHONE_NUMBER }` }>
              { PHONE_NUMBER }
            </Link>
            { '.' }
          </p>
          
        </div>
      
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutSection/index.jsx